import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';

import { PageLayout, PageContentPreloader } from 'common/components';
import { reverseWordsKeepWhitespaceByLines } from 'common/utils';
import EditTemplateForm from '../../_components/EditTemplateForm';

import { getTemplateItem } from '../../_redux';

const EditTemplatePage = ({ templateData, templateDataIsLoaded, getTemplateItem, availableLangs }) => {
  const match = useRouteMatch();
  const history = useHistory();
  const { id } = match.params;

  useEffect(() => {
    getTemplateItem({ id });
  }, [getTemplateItem, id]);

  // ar 模板库里存的是展示序，进表单编辑前转回逻辑序（输入顺序），提交时表单会再转回展示序。
  const toFormValues = data =>
    data && data.language === 'ar'
      ? {
          ...data,
          title: reverseWordsKeepWhitespaceByLines(data.title),
          text: reverseWordsKeepWhitespaceByLines(data.text),
        }
      : data;

  return (
    <PageLayout captionSlug="justAddTemplate">
      <PageContentPreloader ready={templateDataIsLoaded} type="bigLine">
        <div className="EditTemplatePage">
          <EditTemplateForm
            id={id}
            history={history}
            initialValues={toFormValues(templateData)}
            languages={availableLangs.map(item => ({ value: item.slug, label: item.niceName }))}
          />
        </div>
      </PageContentPreloader>
    </PageLayout>
  );
};

EditTemplatePage.propTypes = {
  templateData: PropTypes.object.isRequired,
  templateDataIsLoaded: PropTypes.bool.isRequired,
  getTemplateItem: PropTypes.func.isRequired,
  availableLangs: PropTypes.array,
};

EditTemplatePage.defaultProps = {
  availableLangs: [],
};

export default connect(
  state => ({
    templateData: state.backoffice.templates.templateData,
    templateDataIsLoaded: state.backoffice.templates.templateDataIsLoaded,
    availableLangs: state.interfaceConfig.availableLangs,
  }),
  {
    getTemplateItem: id => getTemplateItem.request(id),
  }
)(EditTemplatePage);
